import { appTypes } from './app.types';

export const setSignupWizardActivePageName = (activePageName) => ({
  type: appTypes.SET_SIGNUP_WIZARD_ACTIVE_PAGE_NAME,
  payload: activePageName,
});

export const setAsUnregisteredUser = (unregisteredUser) => ({
  type: appTypes.SET_AS_UNREGISTERED_USER,
  payload: unregisteredUser,
});

export const setUserOtpToken = (otpToken) => ({
  type: appTypes.SET_USER_OTP_TOKEN,
  payload: otpToken,
});

export const setWidgetCode = (widgetCode) => ({
  type: appTypes.SET_WIDGET_CODE,
  payload: widgetCode,
});

export const setWidgetToken = (widgetToekn) => ({
  type: appTypes.SET_WIDGET_TOKEN,
  payload: widgetToekn,
});

export const decrementVerificationCodeTimer = () => ({
  type: appTypes.DECREMENT_VERIFICATION_CODE_TIMER,
});

export const setVerificationCodeTimerStatus = (isTimerStarted) => ({
  type: appTypes.SET_VERIFICATION_CODE_TIMER_STATUS,
  payload: isTimerStarted,
});

export const setIsMobileValidated = (isMobileValidated) => ({
  type: appTypes.SET_IS_MOBILE_VALIDATED,
  payload: isMobileValidated,
});

export const setMobileNumber = (mobile) => ({
  type: appTypes.SET_MOBILE_NUMBER,
  payload: mobile,
});

export const setIsWidgetReady = (status) => ({
  type: appTypes.SET_IS_WIDGET_READY,
  payload: status,
});


export const setLocale = (locale) =>({
  type: appTypes.SET_LOCALE,
  payload: locale,
})